import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

export default function WhyFreelancAI() {
  return (
    <section className="bg-canvas py-24 sm:py-32">
      <Container>
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-24">
          <Reveal>
            <Eyebrow className="text-tone">Why FreelancAI</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-light leading-[1.04] tracking-[-0.04em] text-fg sm:text-5xl">
              AI moves fast. Your business deserves to move with it.
            </h2>
          </Reveal>
          <Reveal delay={120} className="space-y-6 self-end text-base leading-relaxed text-subtle md:text-lg">
            <p>
              AI is creating new ways to grow, reduce costs, and free teams from repetitive work. Turning those
              opportunities into results takes the right expertise and implementation.
            </p>
            <p>
              Our mission is to make that capability accessible. Our internal AI experts and trusted AI partners help
              your organization put AI to work—and keep adapting as technology evolves.
            </p>
          </Reveal>
        </div>
        <Reveal className="mt-16 border-t border-fg/10 pt-8">
          <p className="font-display text-xl font-light tracking-[-0.02em] text-fg sm:text-2xl">
            You lead your business. <span className="text-subtle">We make AI work for it.</span>
          </p>
        </Reveal>
      </Container>
    </section>
  );
}
